





























































































import Vue from 'vue'

export default Vue.extend({
  name: 'App',

  data: () => ({
    primaryDrawer: true as boolean,
  }),

  methods: {
    logout(): void {
      this.$root.$data.isLoggedIn = false
      this.$root.$data.user = null
      document.cookie = `auth-token=;max-age=0;path=/;samesite=strict`
      this.$router.push({ name: 'Login' })
    },
  },
})
